// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGLinkIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  // flex: "0 0 auto",
  // cursor: "pointer"
  cursor: "pointer",
  display: "block",
};

export default class SVGLinkIcon extends PureComponent<ISVGLinkIconProps, {}> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
      >
        <g id="Layer_1">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            stroke="none"
            d="M26.279,0.008c3.217-0.042,5.148,1.731,6.096,4.006
		c0.555,1.334,0.619,3.382,0.038,4.77c-0.582,1.391-1.597,2.258-2.575,3.243c-1.287,1.298-2.571,2.598-3.862,3.893
		c-0.798,0.799-1.579,1.613-2.385,2.403c-0.271,0.264-0.57,0.832-1.023,0.878c-0.065-0.065-0.105-0.057-0.151-0.153
		c-0.106-0.172,0.002-0.983,0-1.298c-0.005-0.671-0.145-1.319-0.303-1.831c-0.062-0.2-0.062-0.542,0.039-0.688
		c0.106-0.313,0.396-0.438,0.605-0.648c0.499-0.501,0.937-1.025,1.477-1.489c0.218-0.186,0.467-0.545,0.681-0.762
		c0.745-0.75,1.49-1.5,2.234-2.251c0.624-0.629,1.589-1.387,2.044-2.137c0.114-0.305,0.228-0.61,0.341-0.916
		c0.491-1.898-1.09-3.325-2.348-3.663c-1.724-0.464-2.784,0.9-3.56,1.564c-0.141,0.122-0.248,0.321-0.378,0.458
		c-0.493,0.517-1.012,1.019-1.515,1.526c-1.565,1.578-3.132,3.152-4.695,4.731c-0.805,0.813-2.137,1.737-2.272,3.167
		c-0.1,1.06,0.396,2.197,1.022,2.67c0.401,0.304,0.931,0.45,1.061,1.031c0.047,0.213-0.105,0.523-0.189,0.649
		c-0.243,0.359-0.689,0.635-0.984,0.954c-0.12,0.128-0.229,0.329-0.379,0.419c-0.165,0.1-0.502,0.158-0.72,0.076
		c-0.471-0.177-0.841-0.621-1.174-0.953c-0.769-0.768-1.349-1.671-1.704-2.861c-0.493-1.653-0.027-3.752,0.644-4.847
		c0.631-1.029,1.552-1.803,2.385-2.632c1.32-1.314,2.617-2.653,3.938-3.968c0.775-0.771,1.502-1.589,2.272-2.365
		c0.152-0.153,0.353-0.255,0.493-0.42c0.424-0.502,0.956-1.092,1.514-1.45c0.585-0.375,1.279-0.704,2.007-0.916
		C25.284,0.103,26.025,0.167,26.279,0.008z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            stroke="none"
            d="M17.949,12.484c0.763,0.052,1.109,0.645,1.553,1.03
		c1.581,1.375,2.434,4.426,1.363,6.982c-0.719,1.717-2.4,2.991-3.635,4.235c-0.959,0.966-1.88,1.972-2.84,2.938
		c-0.63,0.636-1.321,1.213-1.931,1.869c-0.917,0.989-1.852,2.065-3.029,2.786c-1.119,0.686-3.214,1.058-4.809,0.572
		c-2.229-0.679-3.68-2.204-4.354-4.464c-0.232-0.777-0.383-1.937-0.151-2.862c0.14-0.561,0.28-1.074,0.491-1.564
		c0.476-1.096,1.373-1.841,2.159-2.633c1.25-1.259,2.502-2.515,3.749-3.777c0.895-0.905,1.795-1.804,2.688-2.709
		c0.248-0.25,0.706-0.914,1.099-0.953c0.065,0.065,0.104,0.057,0.151,0.151c0.106,0.173-0.003,0.983,0,1.298
		c0.005,0.671,0.145,1.319,0.303,1.831c0.062,0.201,0.063,0.543-0.039,0.688c-0.102,0.318-0.413,0.489-0.644,0.687
		c-0.127,0.108-0.22,0.299-0.34,0.419c-0.291,0.293-0.619,0.547-0.909,0.84c-1.113,1.117-2.184,2.277-3.294,3.396
		c-0.609,0.613-1.398,1.194-1.855,1.946c-1.158,1.904,0.242,3.96,1.703,4.501c0.578,0.214,1.581,0.142,2.083-0.076
		c0.707-0.306,1.126-0.829,1.628-1.335c0.593-0.598,1.187-1.196,1.779-1.794c1.098-1.106,2.232-2.176,3.333-3.281
		c0.385-0.388,0.708-0.879,1.136-1.221c0.467-0.374,0.953-0.867,1.325-1.336c0.211-0.265,0.555-0.451,0.756-0.725
		c0.483-0.654,0.907-1.779,0.569-2.823c-0.203-0.628-0.613-1.252-1.098-1.603c-0.198-0.143-0.477-0.208-0.644-0.381
		c-0.088-0.092-0.103-0.253-0.189-0.344c-0.013-0.273-0.042-0.461,0.076-0.687c0.2-0.381,0.792-0.788,1.098-1.106
		c0.082-0.084,0.134-0.236,0.228-0.305C17.591,12.574,17.802,12.582,17.949,12.484z"
          />
          <g>
            <path
              strokeWidth="0.5"
              strokeMiterlimit="10"
              d="M32.4,33.475
			c-0.11,0-0.195-0.013-0.255-0.038c-0.06-0.025-0.115-0.098-0.165-0.218l-0.945-2.475h-4.665l-0.945,2.475
			c-0.05,0.12-0.103,0.192-0.158,0.218c-0.055,0.025-0.138,0.038-0.248,0.038h-1.455c-0.16,0-0.265-0.028-0.315-0.083
			c-0.05-0.055-0.045-0.153,0.015-0.292l4.365-10.92c0.07-0.17,0.19-0.255,0.36-0.255h1.455c0.129,0,0.215,0.018,0.255,0.053
			c0.04,0.035,0.085,0.107,0.135,0.217L34.17,33.1c0.06,0.15,0.068,0.25,0.022,0.3c-0.045,0.05-0.152,0.075-0.322,0.075H32.4z
			 M27.076,28.9h3.255l-1.62-4.245L27.076,28.9z"
            />
          </g>
        </g>
      </svg>
    );
  }
}
